import React, {useContext, useState} from "react";
import * as Sentry from '@sentry/browser';
import {FormattedMessage, useIntl} from "react-intl";
import Api from "../../../Api";
import {InputHelper, PasswordInputHelper} from "../../Utils/FieldsHelper";
import MessageContext from "../../../MessageContext";

import classes from "./styles.module.css";

function AccountAdd({token, onAccountAdd}) {
    const [form, setForm] = useState({username: "", email: "", password: ""});
    const [isLoading, setIsLoading] = useState(false);
    const {onMessage} = useContext(MessageContext);
    const intl = useIntl();

    function onChange(name, value) {
        setForm({...form, [name]: value});
    }

    function normalizeError(msg) {
        return msg
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "_")
            .replace(/^_+|_+$/g, "");
    }

    function addAccount() {
        setIsLoading(true);

        new Api({token})
            .addAccount(form)
            .then((r) => {
                if (r.status === 422 && r.errors) {
                    const localizedErrors = [];

                    Object.entries(r.errors).forEach(([field, messages]) => {
                        messages.forEach(errorMsg => {
                            const translationKey = `AccountAdd.validation.${field}.${normalizeError(errorMsg)}`;

                            const localized = intl.formatMessage(
                                {id: translationKey, defaultMessage: errorMsg}
                            );

                            localizedErrors.push(localized);
                        });
                    });

                    onMessage({
                        type: "error",
                        message: localizedErrors.join(" ")
                    });

                } else if (!r.errors) {
                    onMessage({
                        type: "success",
                        message: intl.formatMessage({id: "AccountAdd.success.message.created"})
                    });
                    setForm({username: "", email: "", password: ""});
                    onAccountAdd();
                } else {
                    const errors = Object.values(r.errors).flat().join(" ");
                    onMessage({
                        type: "error",
                        message: intl.formatMessage(
                            {id: "AccountAdd.error.message.create"},
                            {errors}
                        )
                    });
                }
            })
            .catch((err) => {
                Sentry.captureException(err);
                onMessage({
                    type: "error",
                    message: intl.formatMessage({id: "AccountAdd.error.server"})
                });
            })
            .finally(() => setIsLoading(false));
    }


    return (
        <div>
            <InputHelper
                onChange={onChange}
                value={form.username}
                placeholder={"john777"}
                fieldName={"username"}
                label={"FieldsHelper.label.username"}
                changeRegexp={/[^A-Za-z0-9]+/g}
                blurRegexp={/^[A-Za-z0-9]{4,10}$/}
                changeMessage={"FieldsHelper.error.onlyLatinUsername"}
                blurMessage={"FieldsHelper.error.onlyLatinUsername"}
                isDisabled={isLoading}
            />

            <InputHelper
                onChange={onChange}
                value={form.email}
                placeholder={"example@email.ru"}
                fieldName={"email"}
                label={"FieldsHelper.label.email"}
                changeRegexp={/[^A-Za-z0-9\s_@.-]+/g}
                blurRegexp={/^(([^<>()[/\]\\.,;:\s@"]+(\.[^<>()[/\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/}
                changeMessage={"FieldsHelper.error.charactersEmail"}
                blurMessage={"FieldsHelper.error.checkEmail"}
                isDisabled={isLoading}
            />

            <PasswordInputHelper onChange={onChange} value={form.password} isDisabled={isLoading}/>

            <button className={classes.Btn} onClick={addAccount} disabled={isLoading}>
                <FormattedMessage id="AccountAdd.btn.add" defaultMessage="Добавить аккаунт" />
            </button>
        </div>
    );
}

export default AccountAdd;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/AccountAdd/index.js